import { UserRole, UserRoles } from "../constants/roles";

/**
 * Maps internal role values to user-friendly display names
 */
export const getRoleDisplayName = (role: UserRole | string): string => {
  switch (role) {
    case UserRoles.SUPER_ADMIN:
    case "SuperAdmin":
      return "Super Admin";
    case UserRoles.ADMIN:
    case "Admin":
      return "Admin";
    case UserRoles.DISPATCHER:
    case "Dispatcher":
      return "Dispatcher";
    case UserRoles.TRUCK_DRIVER:
    case "TruckDriver":
      return "Truck Driver";
    case UserRoles.FLEET:
    case "Fleet":
      return "Fleet";
    case UserRoles.SAFETY:
    case "Safety":
      return "Safety";
    case UserRoles.RECRUITING:
    case "Recruiting":
      return "Recruiting";
    case UserRoles.ACCOUNTING:
    case "Accounting":
      return "Accounting";
    case UserRoles.IFTA_ADMIN:
    case "IftaAdmin":
      return "IFTA Admin";
    default:
      return role;
  }
};

/**
 * Maps display names back to internal role values
 */
export const getRoleFromDisplayName = (displayName: string): UserRole => {
  switch (displayName) {
    case "Super Admin":
      return UserRoles.SUPER_ADMIN;
    case "Admin":
      return UserRoles.ADMIN;
    case "Dispatcher":
      return UserRoles.DISPATCHER;
    case "Truck Driver":
      return UserRoles.TRUCK_DRIVER;
    case "Fleet":
      return UserRoles.FLEET;
    case "Safety":
      return UserRoles.SAFETY;
    case "Recruiting":
      return UserRoles.RECRUITING;
    case "Accounting":
      return UserRoles.ACCOUNTING;
    case "IFTA Admin":
      return UserRoles.IFTA_ADMIN;
    default:
      return displayName as UserRole;
  }
};
